import { DriverCredentialAttribute } from '../../driver/models/credential/driver-credential-attribute.model';

export class DriverAttributeviewModel extends DriverCredentialAttribute {
    public attributeAccessTypeId: number;
    public attributeCategory: string;
    public code: string;
    public displayValue: string;
    public source: string;
    public endDate: Date;
}
